import { Feed } from "@/components/Feed";
import { StrictMode } from "react";
import { hydrateRoot } from "react-dom/client";
import { loadInitialData } from "./util";

window.addEventListener("DOMContentLoaded", () => {
  loadInitialData("feed", (data, domNode) => {
    const { oois } = data;
    hydrateRoot(
      domNode,
      <StrictMode>
        <Feed items={oois} />
      </StrictMode>
    );
  });
});
